import { useDispatch, useSelector } from "react-redux";
import { ESITI, ROOT, SCREENINGCOLONRETTO } from "../../global/urlMapping"
import { Redirect } from "../tools/Redirect"
import { useEffect } from "react";
import { campagnaSelector } from "../../modules/persistentStore/selectors";
import { CircularProgress } from "@mui/material";
import { isAuthenticatedSelector } from "../../modules/auth/selectors";
import { Box } from "@mui/system";
import { postLoginAction } from "../../modules/postLogin/actions";
import { LOADING } from "../../global/statusLabels";
import { useNavigate } from "react-router-dom";
import { postLoginSelector } from "../../modules/postLogin/selectors";


export const PostLoginLanding = () => {//pagina di atterraggio post login
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const isAuthenticated = useSelector(isAuthenticatedSelector)
    const postLogin = useSelector(postLoginSelector)

    const campagna = useSelector(campagnaSelector)//per sapere in quale campagna ha cliccato l'utente

    useEffect(() => {
        if (!postLogin?.value && postLogin?.status !== LOADING) {
            dispatch(postLoginAction())
        }
    }, [dispatch, navigate, postLogin])
    return (
        <Box className="emptyBg" >

            {isAuthenticated ?
                campagna === "CL" ?
                    <Redirect link={SCREENINGCOLONRETTO} />
                    :
                    campagna === 'ESITI' ?
                        < Redirect link={ESITI} />
                        :
                        <Redirect link={ROOT} />
                :
                <CircularProgress sx={{ margin: "10% auto", display: 'flex', alignItems: "center" }} />}
        </Box>
    )
}